import {
  Account,
  Client,
  Databases,
  ExecutionMethod,
  Functions,
  ID,
} from "appwrite";

export const config = {
  endpoint:
    import.meta.env.VITE_APPWRITE_ENDPOINT ||
    "https://sgp.cloud.appwrite.io/v1",

  projectId:
    import.meta.env.VITE_APPWRITE_PROJECT_ID ||
    "6a5ef6b10020741e0a6d",

  databaseId:
    import.meta.env.VITE_APPWRITE_DATABASE_ID ||
    "6a5f8d0a003e3f854522",

  backendFunctionId:
    import.meta.env.VITE_APPWRITE_BACKEND_FUNCTION_ID || "",

  studentRequests:
    import.meta.env
      .VITE_APPWRITE_STUDENT_REQUESTS_COLLECTION_ID ||
    "student_requests",

  advertiserRequests:
    import.meta.env
      .VITE_APPWRITE_ADVERTISER_REQUESTS_COLLECTION_ID ||
    "advertiser_requests",

  siteUrl: (
    import.meta.env.VITE_SITE_URL ||
    window.location.origin
  ).replace(/\/$/, ""),
};

export const client = new Client()
  .setEndpoint(config.endpoint)
  .setProject(config.projectId);

export const account = new Account(client);
export const databases = new Databases(client);
export const functions = new Functions(client);

export { ID };

export async function callSaradiumBackend<T>(
  body: Record<string, unknown>,
): Promise<T> {
  if (!config.backendFunctionId) {
    throw new Error(
      "VITE_APPWRITE_BACKEND_FUNCTION_ID is not configured.",
    );
  }

  const execution = await functions.createExecution({
    functionId: config.backendFunctionId,
    body: JSON.stringify(body),
    async: false,
    xpath: "/",
    method: ExecutionMethod.POST,
    headers: {
      "content-type": "application/json",
    },
  });

  const responseText = execution.responseBody || "";

  if (
    Number(execution.responseStatusCode) < 200 ||
    Number(execution.responseStatusCode) > 299
  ) {
    try {
      const error = JSON.parse(responseText);

      throw new Error(
        error.message || "SARADIUM request failed.",
      );
    } catch (caught) {
      if (caught instanceof Error) {
        throw caught;
      }

      throw new Error("SARADIUM request failed.");
    }
  }

  return JSON.parse(responseText || "{}") as T;
}